import { cn } from "@/lib/utils";
import Image from "next/image";
import type { ComponentProps, ReactNode } from "react";

export default function ProductCardImage({
  src,
  hoverSrc,
  alt,
  width,
  height,
  children,
  ...props
}: Omit<ComponentProps<typeof Image>, "src" | "alt" | "children"> & {
  src?: string;
  hoverSrc?: string;
  alt?: string;
  children?: ReactNode;
}) {
  if (!src) {
    return null;
  }

  return (
    <figure className="bg-primary-100 relative">
      <Image
        className={cn(
          "aspect-4/5 w-full object-contain mix-blend-multiply",
          hoverSrc && "group-hover/product-card:opacity-0",
        )}
        src={src}
        alt={alt ?? ""}
        width={width ?? 600}
        height={height ?? 600}
        {...props}
      />
      {hoverSrc && (
        <Image
          className="absolute inset-0 aspect-4/5 w-full object-cover opacity-0 mix-blend-multiply transition-opacity group-hover/product-card:opacity-100"
          src={hoverSrc}
          alt={alt ?? ""}
          width={width ?? 600}
          height={height ?? 600}
        />
      )}
      {children}
    </figure>
  );
}

ProductCardImage.displayName = "ProductCardImage";
